import { Component, OnInit } from '@angular/core';
import { IndicatorsSearchToolbarModel } from '../../../../models/indicators-search-toolbar-model.model';
import { IndicatorBoxModel } from '../../../../models/indicator-box.model';
import { LoyaltyChart } from '../../../../models/loyalty-chart-config.model';
import { QFilterModel } from '../../../../models/qfilter.model';
import { IndicatorsChartService, IndicatorsService } from '../../../../services/indicators/indicators.service';
import { AnalyticsService } from '../../../../services/analytics/analytics.service';
import { CustomerCampaignService } from '../../../../services/customer/customer-campaign.service';
import { TranslateService } from '@ngx-translate/core';
import { SearchToolbarModelFactoryService } from '../../../../services/search-toolbar-model-factory/search-toolbar-model-factory.service';
import { SearchToolbarDateFunction, SearchToolbarFactoryParameters, SearchToolbarFilterGrouping, SearchToolbarFilterWindow, SearchToolbarSection } from '../../../../models/search-toolbar-factory-parameters.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-assortimento-main-kpi',
    templateUrl: './assortimento-main-kpi.component.html',
    styleUrls: ['./assortimento-main-kpi.component.css']
})
//Pagina 32
export class AssortimentoMainKpiComponent implements OnInit {

    public searchModel: IndicatorsSearchToolbarModel = new IndicatorsSearchToolbarModel();
    public indicators: IndicatorBoxModel[] = [];
    public translations: any;
    public storeError = false;
    public selectOneError: string;
    public data: QFilterModel;
    public invoicePolar: LoyaltyChart;
    public productPolar: LoyaltyChart;

    constructor(
        private indicatorService: IndicatorsService,
        private chartsService: IndicatorsChartService,
        private svcAnalytics: AnalyticsService,
        private srvCustomerCampaign: CustomerCampaignService,
        private translate: TranslateService,
        private searchModelFactory: SearchToolbarModelFactoryService,
    ) {

    }

    ngOnInit() {
        const searchParams: SearchToolbarFactoryParameters = new SearchToolbarFactoryParameters();
        searchParams.svcAnalytics = this.svcAnalytics;
        searchParams.dateFunctionType = SearchToolbarDateFunction.VaDates;
        searchParams.finestra = SearchToolbarFilterWindow.ThirtyTwo;
        searchParams.raggruppamento = SearchToolbarFilterGrouping.All;
        searchParams.disabledSections = [SearchToolbarSection.CardModes, SearchToolbarSection.Clusterlist, SearchToolbarSection.GroupTypes, SearchToolbarSection.Areas ];
        this.searchModelFactory.buildSearchToolbarModel(searchParams).subscribe((model) => {
            this.searchModel = model;
        });

        this.translate.get([
            'promo.categoryInvestmentTypePromo',
            'promo.averageDiscountPerStoreChannel',
            'promo.investmentContactChannel',
            'promo.singoloPdv',
            'promo.mediaFormato',
            'promo.fatturato',
            'promo.articoli_assortimento'
        ]).subscribe((t) => {
            this.translations = {
                categoryInvestmentTypePromo: t['promo.categoryInvestmentTypePromo'],
                averageDiscountPerStoreChannel: t['promo.averageDiscountPerStoreChannel'],
                investmentContactChannel: t['promo.investmentContactChannel'],
                singoloPdv: t['promo.singoloPdv'],
                mediaFormato: t['promo.mediaFormato'],
                fatturato: t['promo.fatturato'],
                articoli_assortimento: t['promo.articoli_assortimento']
            };
        });

        this.translate.get('store.selectOneErrorMsg').subscribe(msg => { this.selectOneError = msg; });

        this.initCharts();
    }

    initCharts() {
        this.invoicePolar = new LoyaltyChart('line');
        this.invoicePolar.options.chart.polar = true;
        this.invoicePolar.options.xAxis = {categories: [],tickmarkPlacement: 'on',lineWidth: 0};
        this.productPolar = new LoyaltyChart('line');
        this.productPolar.options.chart.polar = true;
        this.productPolar.options.xAxis = {categories: [],tickmarkPlacement: 'on',lineWidth: 0};
    }

    setChartInstance(chart: LoyaltyChart, chartInstance) {
        chart.instance = chartInstance;
    }


    searchValueTrend(data: QFilterModel) {
        this.data = data;

        if (data['stores'] != null) {
            this.translate.get([
                'indicator.fatturato',
                'indicator.quantita_vendute',
                'indicator.prezzo_medio',
                'indicator.tot_articoli'
            ]).subscribe(t => {
                this.indicators = [];

                Observable.zip(
                    this.indicatorService.indicatorCalculation('stores.Q162', this.data),
                    this.indicatorService.indicatorCalculation('stores.Q165', this.data)
                ).subscribe(
                    ([Q162, Q165]) => {

                        /*162*/
                        this.indicators.push(new IndicatorBoxModel([Q162.find(r => r.name === 'fatturato')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                        /*162*/
                        this.indicators.push(new IndicatorBoxModel([Q162.find(r => r.name === 'quantita_vendute')], {dynamic: true, decimal_value: 1, decimal_prec_value: 1}, t));
                        /*162*/
                        this.indicators.push(new IndicatorBoxModel([Q162.find(r => r.name === 'prezzo_medio')], {dynamic: true, decimal_value: 2, decimal_prec_value: 2, unit_period_prec: '€'}, t));
                        /*165*/
                        this.indicators.push(new IndicatorBoxModel([Q165.find(r => r.name === 'tot_articoli')], {dynamic: true, decimal_value: 0, decimal_prec_value: 0}, t));

                    });

            });


            this.polarInit (data, 'stores.Q166', this.invoicePolar);
            this.polarInit (data, 'stores.Q167', this.productPolar);

        } else {
            this.data = null;
            this.storeError = true;
        }

    }

    public toogleErrorStoreDialog() {
        this.storeError = !this.storeError;
    }


    polarInit (data, query, chart) {

        function onlyUnique (value, index, self) {
            return self.indexOf (value) === index;
        }

        function dictToArray (a) {
            let values = [];
            for (let key in a) {
                values.push(a[key]);
            }
            return values;
        }

        Observable.zip (
            this.indicatorService.getChart(query, data, false)
        ).subscribe( ([res]) => {

            let valori      = res.series[1].serie.filter (onlyUnique);
            let dictMedia   = {};
            let dictNegozio = {};
            let serie0      = res.series[0].serie;
            let serie1      = res.series[1].serie;
            let serie2      = res.series[2].serie;
            let series      = [];
            for (let i = 0; i < valori.length; i++) {
                dictMedia[valori[i]] = 0;
                dictNegozio[valori[i]] = 0;
            }
            for (let i = 0; i < serie0.length; i++) {
                if (serie0[i].localeCompare ("MEDIA FORMATO") == 0) {
                    dictMedia[serie1[i]] = serie2[i];
                } else {
                    dictNegozio[serie1[i]] = serie2[i];
                }
            }
            series.push ( { name: this.translations.mediaFormato, data: dictToArray (dictNegozio), type: "area", color: "#26437a" } );
            series.push ( { name: this.translations.singoloPdv, data: dictToArray (dictMedia), type: "area", color: "#fec55c" } );

            if (chart.instance) {
                while (chart.instance.series.length > 0) {
                    chart.instance.series[0].remove(true);
                }
            }
            chart.options.series = series;
            chart.options.xAxis.categories = valori;

            for (let i = 0; i < series.length; i++) {

                chart.instance.addSeries (series[i]);
            }
            chart.instance.update(chart.options);
            chart.instance.redraw();

        });
    }


}



// WEBPACK FOOTER //
// ./src/app/views/store/assortimento/assortimento-main-kpi/assortimento-main-kpi.component.ts